import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { H4 } from '@xo-union/tk-ui-typography';
import LinkButton from '../LinkButton';
import styles from './share.scss';

interface Props {
  hideRecaptcha: boolean;
  setIsSubmitting: (val: boolean) => void;
  setHideRecaptcha: (val: boolean) => void;
  recaptchaRef: React.RefObject<{
    reset: () => void;
    getValue: () => string;
  }>;
  submitForm: () => void;
}
const recaptchaRefKey = process.env.REACT_APP_RECAPTCHA_SITEKEY;

const ReCaptcha: React.FC<Props> = ({ hideRecaptcha, recaptchaRef, submitForm, setHideRecaptcha, setIsSubmitting }) => {
  const submit = () => {
    setIsSubmitting(true);
    submitForm();
  };
  return (
    <div className={`${styles.recaptcha} ${hideRecaptcha ? styles.hide : ''}`}>
      <div className={styles.recaptchaInner}>
        <H4 className={styles.recaptchaLabel}>
          <strong>Please confirm you're not a robot</strong>
        </H4>
        <ReCAPTCHA size="normal" ref={recaptchaRef} sitekey={recaptchaRefKey} onChange={submit} />
      </div>
      <LinkButton
        className={styles.recaptchaCancel}
        onClick={() => {
          setHideRecaptcha(true);
        }}
      >
        Cancel
      </LinkButton>
    </div>
  );
};

export default ReCaptcha;
